module.exports = __webpack_public_path__ + "static/img/brees-2003-slide-1.51da12d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-slide-1.jpg
// module id = linz
// module chunks = 1